// extracted by mini-css-extract-plugin
module.exports = {"root":"GraphQLQueryData_root__YZryb"};